import { inject, Injectable } from "@angular/core";
import { WidgetType } from "../models/dashboard.model";
import { DashboardFacadeService } from "./dashboard-facade.service";
import { format } from "date-fns";
import { OF } from "../../of/models/of.model";
import { CaInfos } from "../../analyse-ca/models/ca-infos.model";
import { OfEtat } from "../../of/enums/etat-of.enum";
import { EnumsUtils } from "../../../shared/utils/enums.utils";
import { Pass } from "../../administration/models/pass.model";
import { parseNumber } from "../../../shared/utils/number-utils.service";

@Injectable({
  providedIn: "root",
})
export class WidgetHelperService {
  static widgets = [
    {
      name: "dashboard_ui.cat_production",
      type: "production",
      icon: "rocket_launch",
      modules: [
        {
          name: "dashboard_ui.w_productivite_moyenne",
          icon: "list",
          description: "dashboard_ui.w_productivite_moyenne_desc",
          enabled: false,
          type: WidgetType.PRODUCTIVITE_MOYENNE,
          metadata: null,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_ofs_en_cours",
          icon: "list",
          description: "dashboard_ui.w_ofs_en_cours_desc",
          enabled: false,
          type: WidgetType.OF_EN_COURS,
          metadata: null,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_heures_travaillees",
          icon: "list",
          description: "dashboard_ui.w_heures_travaillees_desc",
          enabled: false,
          type: WidgetType.HEURES_TRAVAILLES,
          metadata: null,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_quantite_ofs",
          icon: "list",
          description: "dashboard_ui.w_quantite_ofs_desc",
          enabled: false,
          type: WidgetType.QUANTITE_OF,
          w: 2,
          h: 2,
        },
        // {
        //   name: "Cadence réelle",
        //   icon: "assessment",
        //   description: "",
        //   enabled: false,
        //   type: WidgetType.CADENCE_REELLE,
        //   w: 2,
        //   h: 2,
        // },
        {
          name: "dashboard_ui.w_ofs",
          icon: "list",
          description: "dashboard_ui.w_ofs_desc",
          enabled: false,
          type: WidgetType.OF_LIST,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_specifications",
          icon: "list",
          description: "dashboard_ui.w_specifications_desc",
          enabled: false,
          type: WidgetType.SPECIFICATION_LIST,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_quantite_produite_periode",
          icon: "insert_chart_outlined",
          description: "dashboard_ui.w_quantite_produite_periode_desc",
          enabled: false,
          type: WidgetType.QUANTITE_PRODUITE_PERIODE,
          w: 2,
          h: 2,
        },
      ],
    },
    {
      name: "dashboard_ui.cat_financier",
      type: "financier",
      icon: "euro",
      modules: [
        {
          name: "dashboard_ui.w_ca_cumule",
          icon: "stacked_line_chart",
          description: "dashboard_ui.w_ca_cumule_desc",
          enabled: false,
          type: WidgetType.CA_CUMULE,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_ca_par_periode",
          icon: "insert_chart_outlined",
          description: "dashboard_ui.w_ca_par_periode_desc",
          enabled: false,
          type: WidgetType.CA_PAR_PERIODE,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_ca_delta",
          icon: "insert_chart_outlined",
          description: "dashboard_ui.w_ca_delta_desc",
          enabled: false,
          type: WidgetType.CA_DELTA,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_ca_n_moins_1",
          icon: "compare_arrows",
          description: "dashboard_ui.w_ca_n_moins_1_desc",
          enabled: false,
          type: WidgetType.CA_N_MOINS_1,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_repartition_par_client",
          icon: "pie_chart",
          description: "dashboard_ui.w_repartition_par_client_desc",
          enabled: false,
          type: WidgetType.REPARTITION_PAR_CLIENT,
          w: 2,
          h: 2,
        },
      ],
    },
    {
      name: "dashboard_ui.cat_commandes",
      type: "commandes",
      icon: "receipt_long",
      modules: [
        {
          name: "dashboard_ui.w_commandes_fournisseurs",
          icon: "list",
          description: "dashboard_ui.w_commandes_fournisseurs_desc",
          enabled: false,
          type: WidgetType.COMMANDE_FOURNISSEUR_LIST,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_commandes_clients",
          icon: "list",
          description: "dashboard_ui.w_commandes_clients_desc",
          enabled: false,
          type: WidgetType.COMMANDE_CLIENT_LIST,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_couverture_commandes",
          icon: "inventory_2",
          description: "dashboard_ui.w_couverture_commandes_desc",
          enabled: false,
          type: WidgetType.COUVERTURE_COMMANDES,
          w: 2,
          h: 4,
        },
      ],
    },
    {
      name: "dashboard_ui.cat_stock",
      type: "stock",
      icon: "stacked_bar_chart",
      modules: [
        {
          name: "dashboard_ui.w_lot_par_etat",
          icon: "list",
          description: "dashboard_ui.w_lot_par_etat_desc",
          enabled: false,
          type: WidgetType.LOT_PAR_ETAT,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_valeur_par_famille",
          icon: "donut_large",
          description: "dashboard_ui.w_valeur_par_famille_desc",
          enabled: false,
          type: WidgetType.VALEUR_PAR_FAMILLE,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_evolution_valeur",
          icon: "show_chart",
          description: "dashboard_ui.w_evolution_valeur_desc",
          enabled: false,
          type: WidgetType.EVOLUTION_VALEUR,
          w: 2,
          h: 2,
        },
      ],
    },
    {
      name: "dashboard_ui.cat_supervision",
      type: "supervision",
      icon: "visibility",
      modules: [
        {
          name: "dashboard_ui.w_planning",
          icon: "calendar_month",
          description: "dashboard_ui.w_planning_desc",
          enabled: false,
          type: WidgetType.PLANNING,
          w: 4,
          h: 2,
        },
        {
          name: "dashboard_ui.w_live_production",
          icon: "monitor_heart",
          description: "dashboard_ui.w_live_production_desc",
          enabled: false,
          type: WidgetType.LIVE_PRODUCTION,
          w: 2,
          h: 3,
        },
      ],
    },
    {
      name: "dashboard_ui.cat_qualite",
      type: "qualite",
      icon: "verified",
      modules: [
        {
          name: "dashboard_ui.w_nc_stats",
          icon: "donut_large",
          description: "dashboard_ui.w_nc_stats_desc",
          enabled: false,
          type: WidgetType.NC_STATS,
          metadata: null,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_nc_closure_metrics",
          icon: "timer",
          description: "dashboard_ui.w_nc_closure_metrics_desc",
          enabled: false,
          type: WidgetType.NC_CLOSURE_METRICS,
          metadata: null,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_nc_supplier_compliance",
          icon: "leaderboard",
          description: "dashboard_ui.w_nc_supplier_compliance_desc",
          enabled: false,
          type: WidgetType.NC_SUPPLIER_COMPLIANCE,
          metadata: null,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_certificat_bio_echeance",
          icon: "eco",
          description: "dashboard_ui.w_certificat_bio_echeance_desc",
          enabled: false,
          type: WidgetType.CERTIFICAT_BIO_ECHEANCE,
          metadata: null,
          w: 2,
          h: 2,
        },
      ],
    },
    {
      name: "dashboard_ui.cat_ligne",
      type: "ligne",
      icon: "precision_manufacturing",
      modules: [
        {
          name: "dashboard_ui.w_quantite_produite",
          icon: "insert_chart_outlined",
          description: "dashboard_ui.w_quantite_produite_desc",
          enabled: false,
          type: WidgetType.QUANTITE_PRODUITE_LIGNE,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_main_oeuvre",
          icon: "pie_chart",
          description: "dashboard_ui.w_main_oeuvre_desc",
          enabled: false,
          type: WidgetType.MAIN_OEUVRE_LIGNE,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_productivite_ligne",
          icon: "insert_chart_outlined",
          description: "dashboard_ui.w_productivite_ligne_desc",
          enabled: false,
          type: WidgetType.PRODUCTIVITE_LIGNE,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_couts_matiere_personnel",
          icon: "stacked_bar_chart",
          description: "dashboard_ui.w_couts_matiere_personnel_desc",
          enabled: false,
          type: WidgetType.COUTS_LIGNE,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_ofs_ligne",
          icon: "list",
          description: "dashboard_ui.w_ofs_ligne_desc",
          enabled: false,
          type: WidgetType.OFS_LIGNE,
          w: 2,
          h: 2,
        },
        {
          name: "dashboard_ui.w_articles_produits",
          icon: "pie_chart",
          description: "dashboard_ui.w_articles_produits_desc",
          enabled: false,
          type: WidgetType.ARTICLES_PRODUITS_LIGNE,
          w: 2,
          h: 2,
        },
      ],
    },
  ];

  facade = inject(DashboardFacadeService);

  constructor() {}

  static getWidgetSize(type: WidgetType): { w: number; h: number } {
    for (const category of this.widgets) {
      const widget = category.modules.find((widget) => widget.type === type);
      if (widget) {
        return {
          h: widget.h,
          w: widget.w,
        };
      }
    }
    return null;
  }

  static getCaCumuleChart(
    data: { date: string; montant: number }[],
    filters: {
      timeScale: string;
      period: string;
      exerciceStart?: string;
    } = { timeScale: "YTD", period: "m" },
  ) {
    const sorted = [...data].sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );
    const { data: dataToUse } = this.filterByTimeScale(
      sorted,
      filters.timeScale,
      filters.exerciceStart,
    );

    const res: { date: string; montant: number }[] = [];

    for (let i = 0; i < dataToUse.length; i += 1) {
      const foundDate = res.findIndex(
        (r) =>
          r.date === this.getDateForPeriod(dataToUse[i].date, filters.period),
      );

      if (foundDate > -1) {
        res[foundDate].montant += dataToUse[i].montant;
      } else {
        res.push({
          date: this.getDateForPeriod(dataToUse[i].date, filters.period),
          montant: dataToUse[i].montant,
        });
      }
    }

    res.forEach((e, index) => {
      if (index !== 0) {
        e.montant += res[index - 1].montant;
      }
    });

    return res;
  }

  static getCaInfosCumuleChart(
    data: CaInfos[],
    filters: {
      timeScale: string;
      period: string;
    } = { timeScale: "YTD", period: "m" },
  ) {
    let dataToUse = [...data];

    let refDate = new Date();

    if (filters) {
      let dateOffset = 0;
      switch (filters.timeScale) {
        case "1 j":
          dateOffset = 24 * 60 * 60 * 1000 * 1; //1 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 j":
          dateOffset = 24 * 60 * 60 * 1000 * 5; //5 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30; //1 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "6 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 6; //6 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "YTD":
          refDate = new Date(`${refDate.getFullYear()}-01-01`);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12; //1 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12 * 5; //5 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
      }
    }

    const res = [];

    dataToUse = dataToUse.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    for (let i = 0; i < dataToUse.length; i += 1) {
      const foundDate = res.findIndex(
        (r) =>
          r.date === this.getDateForPeriod(dataToUse[i].date, filters.period),
      );

      if (foundDate > -1) {
        res[foundDate].montant += parseNumber(dataToUse[i].montant);
      } else {
        let montantTotal = 0;

        if (i > 0) {
          for (let j = 0; j < i; j += 1) {
            const montant = parseNumber(dataToUse[j].montant);
            if (montant > 0) {
              montantTotal += montant;
            }
          }
        }

        res.push({
          date: this.getDateForPeriod(dataToUse[i].date, filters.period),
          montant: montantTotal,
        });
      }
    }

    return res;
  }

  static getCaParAnnee(
    data: { date: string; montant: number; montant_echeance: number }[],
    filters: {
      period: string;
    } = { period: "m" },
  ) {
    let dataToUse = [...data].filter(
      (d) =>
        new Date(d.date).getFullYear() === new Date().getFullYear() ||
        new Date(d.date).getFullYear() === new Date().getFullYear() - 1,
    );

    const labels = [];
    let res: { annee: number; montants: number[] }[] = [];

    dataToUse = dataToUse.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    for (let i = 0; i < dataToUse.length; i += 1) {
      const foundAnnee = res.findIndex(
        (r) => r.annee === new Date(dataToUse[i].date).getFullYear(),
      );

      //si on trouve pas l'année on la créé, on incrémente les valeurs après
      if (foundAnnee === -1) {
        res.push({
          annee: new Date(dataToUse[i].date).getFullYear(),
          montants: [],
        });
      }
    }

    res = res.sort((a, b) => a.annee - b.annee);

    for (let i = 0; i < dataToUse.length; i += 1) {
      let dateRef: string;
      switch (filters.period) {
        case "j":
          dateRef = format(new Date(dataToUse[i].date), "dd/MM");
          break;
        case "s":
          dateRef = this.getWeek(new Date(dataToUse[i].date));
          break;
        case "m":
          dateRef = format(new Date(dataToUse[i].date), "MMM");
          break;
      }

      const foundLabel = labels.findIndex((l) => l === dateRef);

      //incrément des valeurs
      if (foundLabel > -1) {
        res.forEach((r) => {
          if (r.annee === new Date(dataToUse[i].date).getFullYear()) {
            r.montants[r.montants.length - 1] += dataToUse[i].montant;
          }
        });
      } else {
        labels.push(dateRef);
        res.forEach((r) => {
          if (r.annee === new Date(dataToUse[i].date).getFullYear()) {
            r.montants.push(dataToUse[i].montant);
          } else {
            r.montants.push(0);
          }
        });
      }
    }

    return { labels, res };
  }

  static getCaInfosParAnnee(
    data: CaInfos[],
    filters: {
      period: string;
    } = { period: "m" },
  ) {
    let dataToUse = [...data].filter(
      (d) =>
        new Date(d.date).getFullYear() === new Date().getFullYear() ||
        new Date(d.date).getFullYear() === new Date().getFullYear() - 1,
    );

    const labels = [];
    let res: { annee: number; montants: number[] }[] = [];

    dataToUse = dataToUse.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    for (let i = 0; i < dataToUse.length; i += 1) {
      const foundAnnee = res.findIndex(
        (r) => r.annee === new Date(dataToUse[i].date).getFullYear(),
      );

      //si on trouve pas l'année on la créé, on incrémente les valeurs après
      if (foundAnnee === -1) {
        res.push({
          annee: new Date(dataToUse[i].date).getFullYear(),
          montants: [],
        });
      }
    }

    res = res.sort((a, b) => a.annee - b.annee);

    for (let i = 0; i < dataToUse.length; i += 1) {
      let dateRef: string;
      switch (filters.period) {
        case "j":
          dateRef = format(new Date(dataToUse[i].date), "dd/MM");
          break;
        case "s":
          dateRef = this.getWeek(new Date(dataToUse[i].date));
          break;
        case "m":
          dateRef = format(new Date(dataToUse[i].date), "MMM");
          break;
      }

      const foundLabel = labels.findIndex((l) => l === dateRef);

      //incrément des valeurs
      if (foundLabel > -1) {
        res.forEach((r) => {
          if (r.annee === new Date(dataToUse[i].date).getFullYear()) {
            r.montants[r.montants.length - 1] += parseNumber(
              dataToUse[i].montant,
            );
          }
        });
      } else {
        labels.push(dateRef);
        res.forEach((r) => {
          if (r.annee === new Date(dataToUse[i].date).getFullYear()) {
            r.montants.push(parseNumber(dataToUse[i].montant));
          } else {
            r.montants.push(0);
          }
        });
      }
    }

    return { labels, res };
  }

  static getCaDeltaChart(
    data: {
      date: string;
      montant: number;
      montant_echeance: number;
      montant_du: number;
      montant_du_echeance: number;
    }[],
    filters: {
      timeScale: string;
      period: string;
    } = { timeScale: "YTD", period: "m" },
  ) {
    let dataToUse = [...data].sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    let refDate = new Date();

    if (filters) {
      let dateOffset = 0;
      switch (filters.timeScale) {
        case "1 j":
          dateOffset = 24 * 60 * 60 * 1000 * 1; //1 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 j":
          dateOffset = 24 * 60 * 60 * 1000 * 5; //5 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30; //1 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "6 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 6; //6 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "YTD":
          refDate = new Date(`${refDate.getFullYear()}-01-01`);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12; //1 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12 * 5; //5 a
          refDate.setTime(refDate.getTime() - dateOffset);
          break;
      }
    }

    const res = [];

    for (let i = 0; i < dataToUse.length; i += 1) {
      const foundDate = res.findIndex(
        (r) =>
          r.date === this.getDateForPeriod(dataToUse[i].date, filters.period),
      );

      if (foundDate > -1) {
        res[foundDate].montant += dataToUse[i].montant;
        res[foundDate].montant_echeance += dataToUse[i].montant_echeance;
        res[foundDate].montant -= dataToUse[i].montant_du;
        res[foundDate].montant_echeance -= dataToUse[i].montant_du_echeance;
      } else {
        res.push({
          date: this.getDateForPeriod(dataToUse[i].date, filters.period),
          montant: dataToUse[i].montant - dataToUse[i].montant_du,
          montant_echeance:
            dataToUse[i].montant_echeance - dataToUse[i].montant_du_echeance,
        });
      }
    }

    return res;
  }

  static getCaInfosDeltaChart(
    data: CaInfos[],
    filters: {
      timeScale: string;
      period: string;
    } = { timeScale: "YTD", period: "m" },
  ) {
    let dataToUse = [...data].sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    let refDate = new Date();

    if (filters) {
      let dateOffset = 0;
      switch (filters.timeScale) {
        case "1 j":
          dateOffset = 24 * 60 * 60 * 1000 * 1; //1 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 j":
          dateOffset = 24 * 60 * 60 * 1000 * 5; //5 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30; //1 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "6 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 6; //6 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "YTD":
          refDate = new Date(`${refDate.getFullYear()}-01-01`);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12; //1 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12 * 5; //5 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
      }
    }

    const res = [];

    for (let i = 0; i < dataToUse.length; i += 1) {
      const foundDate = res.findIndex(
        (r) =>
          r.date === this.getDateForPeriod(dataToUse[i].date, filters.period),
      );

      if (foundDate > -1) {
        res[foundDate].montant += dataToUse[i].montant;
      } else {
        res.push({
          date: this.getDateForPeriod(dataToUse[i].date, filters.period),
          montant: dataToUse[i].montant,
        });
      }
    }

    return res;
  }

  static getCaPeriodeChart(
    data: {
      date: string;
      montant: number;
    }[],
    filters: {
      timeScale: string;
      period: string;
    } = { timeScale: "YTD", period: "m" },
  ) {
    let dataToUse = [...data].sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    let refDate = new Date();

    if (filters) {
      let dateOffset = 0;
      switch (filters.timeScale) {
        case "1 j":
          dateOffset = 24 * 60 * 60 * 1000 * 1; //1 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 j":
          dateOffset = 24 * 60 * 60 * 1000 * 5; //5 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30; //1 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "6 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 6; //6 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "YTD":
          refDate = new Date(`${refDate.getFullYear()}-01-01`);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12; //1 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12 * 5; //5 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
      }
    }

    const res = [];

    for (let i = 0; i < dataToUse.length; i += 1) {
      const foundDate = res.findIndex(
        (r) =>
          r.date === this.getDateForPeriod(dataToUse[i].date, filters.period),
      );

      if (foundDate > -1) {
        res[foundDate].montant += dataToUse[i].montant;
      } else {
        res.push({
          date: this.getDateForPeriod(dataToUse[i].date, filters.period),
          montant: dataToUse[i].montant,
        });
      }
    }

    return res;
  }

  static filterByTimeScale(
    data: { date: string; montant: number }[],
    timeScale: string,
    exerciceStart?: string,
  ): { data: { date: string; montant: number }[]; refDate: Date } {
    let dataToUse = [...data].sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    let refDate = new Date();

    let dateOffset = 0;
    switch (timeScale) {
      case "1 j":
        dateOffset = 24 * 60 * 60 * 1000 * 1;
        refDate.setTime(refDate.getTime() - dateOffset);
        dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
        break;
      case "5 j":
        dateOffset = 24 * 60 * 60 * 1000 * 5;
        refDate.setTime(refDate.getTime() - dateOffset);
        dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
        break;
      case "1 m":
        dateOffset = 24 * 60 * 60 * 1000 * 30;
        refDate.setTime(refDate.getTime() - dateOffset);
        dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
        break;
      case "6 m":
        dateOffset = 24 * 60 * 60 * 1000 * 30 * 6;
        refDate.setTime(refDate.getTime() - dateOffset);
        dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
        break;
      case "YTD":
        refDate = new Date(`${refDate.getFullYear()}-01-01`);
        dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
        break;
      case "EX": {
        const parts = (exerciceStart ?? "01/01").split("/");
        const day = parseInt(parts[0], 10) || 1;
        const month = parseInt(parts[1], 10) || 1;
        refDate = new Date(refDate.getFullYear(), month - 1, day);
        if (refDate > new Date()) {
          refDate.setFullYear(refDate.getFullYear() - 1);
        }
        dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
        break;
      }
      case "1 a":
        dateOffset = 24 * 60 * 60 * 1000 * 30 * 12;
        refDate.setTime(refDate.getTime() - dateOffset);
        dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
        break;
      case "5 a":
        dateOffset = 24 * 60 * 60 * 1000 * 30 * 12 * 5;
        refDate.setTime(refDate.getTime() - dateOffset);
        dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
        break;
    }

    return { data: dataToUse, refDate };
  }

  static aggregateByPeriod(
    data: { date: string; montant: number }[],
    period: string,
  ): { date: string; montant: number }[] {
    const res: { date: string; montant: number }[] = [];
    for (const item of data) {
      const dateKey = this.getDateForPeriod(item.date, period);
      const found = res.find((r) => r.date === dateKey);
      if (found) {
        found.montant += item.montant;
      } else {
        res.push({ date: dateKey, montant: item.montant });
      }
    }
    return res;
  }

  /**
   * Extrait une clé relative (sans année) pour aligner les périodes de comparaison.
   * Ex: period 'm' + date "03-26" → "03", period 'j' + date "15-03-2026" → "15-03"
   */
  private static getRelativeKey(periodLabel: string, period: string): string {
    switch (period) {
      case "m":
        // "MM-yy" → garder le mois "MM"
        return periodLabel.split("-")[0];
      case "j":
        // "dd-MM-yyyy" → garder "dd-MM"
        return periodLabel.split("-").slice(0, 2).join("-");
      case "s":
        // "Semaine XX - YYYY" → garder "Semaine XX"
        return periodLabel.replace(/ - \d{4}$/, "");
      case "a":
        // "yyyy" → pas de clé relative possible, utiliser l'index
        return periodLabel;
      default:
        return periodLabel;
    }
  }

  static getCaPeriodeComparisonChart(
    data: { date: string; montant: number }[],
    filters: {
      timeScale: string;
      period: string;
      comparison: string | null;
      exerciceStart?: string;
    },
  ): {
    labels: string[];
    current: number[];
    comparison: number[];
    comparisonLabels: string[];
  } {
    // 1. Filtrer les données courantes par timeScale
    const { data: currentData, refDate } = this.filterByTimeScale(
      data,
      filters.timeScale,
      filters.exerciceStart,
    );
    const now = new Date();

    // 2. Agréger par période
    const currentAgg = this.aggregateByPeriod(currentData, filters.period);
    currentAgg.sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    const labels = currentAgg.map((d) => d.date);
    const current = currentAgg.map((d) => d.montant);

    // 3. Calculer les données de comparaison
    let comparison: number[] = [];
    let comparisonLabels: string[] = [];

    if (filters.comparison === "n-1" || filters.comparison === "previous") {
      let compStart: Date;
      let compEnd: Date;

      if (filters.comparison === "n-1") {
        compStart = new Date(refDate);
        compStart.setFullYear(compStart.getFullYear() - 1);
        compEnd = new Date(now);
        compEnd.setFullYear(compEnd.getFullYear() - 1);
      } else {
        const duration = now.getTime() - refDate.getTime();
        compStart = new Date(refDate.getTime() - duration);
        compEnd = new Date(refDate);
      }

      const compData = [...data]
        .filter((d) => {
          const dt = new Date(d.date);
          return dt >= compStart && dt < compEnd;
        })
        .sort(
          (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
        );

      const compAgg = this.aggregateByPeriod(compData, filters.period);
      compAgg.sort(
        (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
      );

      // Aligner par clé relative (mois, jour, semaine) plutôt que par index
      const compMap = new Map<string, { montant: number; label: string }>();
      for (const item of compAgg) {
        const key = this.getRelativeKey(item.date, filters.period);
        compMap.set(key, { montant: item.montant, label: item.date });
      }

      comparison = labels.map((label) => {
        const key = this.getRelativeKey(label, filters.period);
        return compMap.get(key)?.montant ?? 0;
      });

      comparisonLabels = labels.map((label) => {
        const key = this.getRelativeKey(label, filters.period);
        return compMap.get(key)?.label ?? "";
      });
    }

    return { labels, current, comparison, comparisonLabels };
  }

  static getQuantiteProduiteComparisonChart(
    data: {
      date: string;
      ligneDenomination: string;
      quantiteProduite: number;
    }[],
    filters: {
      timeScale: string;
      period: string;
      comparison: string | null;
      selectedLigne: string | null;
    },
  ): {
    labels: string[];
    datasets: { label: string; data: number[]; backgroundColor: string; stack?: string }[];
    comparisonLabels: string[];
  } {
    const LIGNE_COLORS = [
      "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f",
      "#edc948", "#b07aa1", "#ff9da7", "#9c755f", "#bab0ac",
    ];

    // Filtrer par ligne si spécifique
    const filteredData = filters.selectedLigne
      ? data.filter((d) => d.ligneDenomination === filters.selectedLigne)
      : data;

    // Mapper vers { date, montant } pour réutiliser filterByTimeScale/aggregateByPeriod
    const mapped = filteredData.map((d) => ({
      date: d.date,
      montant: d.quantiteProduite,
      ligneDenomination: d.ligneDenomination,
    }));

    // 1. Filtrer par timeScale
    const { data: currentData, refDate } = this.filterByTimeScale(
      mapped,
      filters.timeScale,
    );
    const now = new Date();

    // Extraire les lignes uniques
    const lignes = [...new Set(currentData.map((d) => (d as any).ligneDenomination as string))];

    // Mode "toutes" sans comparaison → stacked, une série par ligne
    if (!filters.selectedLigne && !filters.comparison) {
      const allAgg = this.aggregateByPeriod(currentData, filters.period);
      allAgg.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
      const labels = allAgg.map((d) => d.date);

      const datasets = lignes.map((ligne, i) => {
        const ligneData = currentData.filter((d) => (d as any).ligneDenomination === ligne);
        const ligneAgg = this.aggregateByPeriod(ligneData, filters.period);
        const ligneMap = new Map(ligneAgg.map((a) => [a.date, a.montant]));
        return {
          label: ligne,
          data: labels.map((l) => ligneMap.get(l) ?? 0),
          backgroundColor: LIGNE_COLORS[i % LIGNE_COLORS.length],
          stack: "stack",
        };
      });

      return { labels, datasets, comparisonLabels: [] };
    }

    // Mode "toutes" + comparaison → somme toutes lignes, 2 datasets grouped
    // Mode ligne spécifique → 1 ou 2 datasets grouped
    const currentAgg = this.aggregateByPeriod(currentData, filters.period);
    currentAgg.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
    const labels = currentAgg.map((d) => d.date);
    const current = currentAgg.map((d) => d.montant);

    const datasets: { label: string; data: number[]; backgroundColor: string; stack?: string }[] = [
      {
        label: filters.selectedLigne || "Total",
        data: current,
        backgroundColor: LIGNE_COLORS[0],
      },
    ];

    let comparisonLabels: string[] = [];

    if (filters.comparison === "n-1" || filters.comparison === "previous") {
      let compStart: Date;
      let compEnd: Date;

      if (filters.comparison === "n-1") {
        compStart = new Date(refDate);
        compStart.setFullYear(compStart.getFullYear() - 1);
        compEnd = new Date(now);
        compEnd.setFullYear(compEnd.getFullYear() - 1);
      } else {
        const duration = now.getTime() - refDate.getTime();
        compStart = new Date(refDate.getTime() - duration);
        compEnd = new Date(refDate);
      }

      const compFiltered = filters.selectedLigne
        ? data.filter((d) => d.ligneDenomination === filters.selectedLigne)
        : data;

      const compMapped = compFiltered
        .map((d) => ({ date: d.date, montant: d.quantiteProduite }))
        .filter((d) => {
          const dt = new Date(d.date);
          return dt >= compStart && dt < compEnd;
        })
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

      const compAgg = this.aggregateByPeriod(compMapped, filters.period);
      compAgg.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

      const compMap = new Map<string, { montant: number; label: string }>();
      for (const item of compAgg) {
        const key = this.getRelativeKey(item.date, filters.period);
        compMap.set(key, { montant: item.montant, label: item.date });
      }

      const compData = labels.map((label) => {
        const key = this.getRelativeKey(label, filters.period);
        return compMap.get(key)?.montant ?? 0;
      });

      comparisonLabels = labels.map((label) => {
        const key = this.getRelativeKey(label, filters.period);
        return compMap.get(key)?.label ?? "";
      });

      datasets.push({
        label: filters.comparison === "n-1" ? "N-1" : "Préc.",
        data: compData,
        backgroundColor: LIGNE_COLORS[0] + "60",
      });
    }

    return { labels, datasets, comparisonLabels };
  }

  static getCaInfosPeriodeChart(
    data: CaInfos[],
    filters: {
      timeScale: string;
      period: string;
    } = { timeScale: "YTD", period: "m" },
  ) {
    let dataToUse = [...data].sort(
      (a, b) => new Date(a.date).getTime() - new Date(b.date).getTime(),
    );

    let refDate = new Date();

    if (filters) {
      let dateOffset = 0;
      switch (filters.timeScale) {
        case "1 j":
          dateOffset = 24 * 60 * 60 * 1000 * 1; //1 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 j":
          dateOffset = 24 * 60 * 60 * 1000 * 5; //5 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30; //1 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "6 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 6; //6 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "YTD":
          refDate = new Date(`${refDate.getFullYear()}-01-01`);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12; //1 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12 * 5; //5 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
      }
    }

    const res = [];

    for (let i = 0; i < dataToUse.length; i += 1) {
      const foundDate = res.findIndex(
        (r) =>
          r.date === this.getDateForPeriod(dataToUse[i].date, filters.period),
      );

      if (foundDate > -1) {
        res[foundDate].montant += dataToUse[i].montant;
      } else {
        res.push({
          date: this.getDateForPeriod(dataToUse[i].date, filters.period),
          montant: dataToUse[i].montant,
        });
      }
    }

    return res;
  }

  static getValeurParFamilleChart(
    data: {
      denomination: string;
      total: number;
    }[],
    maxItems: number = 12,
  ) {
    const sorted = [...data].sort((a, b) => b.total - a.total);
    const dataToUse = sorted.slice(0, maxItems);
    const rest = sorted.slice(maxItems);

    if (rest.length > 0) {
      const others = rest.reduce((sum, d) => sum + d.total, 0);
      dataToUse.push({ denomination: "Autres", total: others });
    }

    return {
      labels: dataToUse.map((d) => d.denomination),
      datasets: [
        {
          label: "Répartition",
          data: dataToUse.map((d) => d.total),
        },
      ],
    };
  }

  static getRepartitionParClientChart(
    data: {
      date: string;
      montant: number;
      tiersDenomination: string;
    }[],
    filters: { timeScale: string; threshold: number } = {
      timeScale: "YTD",
      threshold: 20,
    },
  ) {
    let dataToUse = [...data];

    let refDate = new Date();

    if (filters) {
      let dateOffset = 0;
      switch (filters.timeScale) {
        case "1 j":
          dateOffset = 24 * 60 * 60 * 1000 * 1; //1 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 j":
          dateOffset = 24 * 60 * 60 * 1000 * 5; //5 j
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30; //1 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "6 m":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 6; //6 m
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "YTD":
          refDate = new Date(`${refDate.getFullYear()}-01-01`);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "1 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12; //1 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
        case "5 a":
          dateOffset = 24 * 60 * 60 * 1000 * 30 * 12 * 5; //5 a
          refDate.setTime(refDate.getTime() - dateOffset);
          dataToUse = dataToUse.filter((d) => new Date(d.date) >= refDate);
          break;
      }
    }

    let res: { tiersDenomination: string; montant: number; percent: number }[] =
      [];
    let total: number = 0;

    for (let i = 0; i < dataToUse.length; i += 1) {
      const foundTiers = res.findIndex(
        (r) => r.tiersDenomination === dataToUse[i].tiersDenomination,
      );

      if (foundTiers > -1) {
        res[foundTiers].montant += dataToUse[i].montant;
      } else {
        res.push({
          tiersDenomination: dataToUse[i].tiersDenomination,
          montant: dataToUse[i].montant,
          percent: 0,
        });
      }

      total += dataToUse[i].montant;
    }

    res = res.map((r) => {
      return { ...r, percent: Math.round((r.montant / total) * 100) };
    });

    let others = 0;

    res = res.filter((r) => {
      if (filters && r.percent < filters.threshold) {
        others += r.montant;
        return false;
      }
      return true;
    });

    res.push({
      tiersDenomination: "Autres",
      montant: others,
      percent: Math.round((others / total) * 100),
    });

    const d: {
      labels: string[];
      datasets: any[];
    } = {
      labels: [],
      datasets: [
        {
          label: "Répartition",
          data: [],
        },
      ],
    };

    res.forEach((r) => {
      d.labels.push(r.tiersDenomination);
      d.datasets[0].data.push(r.montant);
    });

    return d;
  }

  static MONTHS_SHORT = [
    "Jan", "Fév", "Mar", "Avr", "Mai", "Jun",
    "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc",
  ];

  static getProductiviteData(
    data: { ofs: OF[] },
  ) {
    if (!data) {
      return [];
    }

    // YTD filter
    const yearStart = new Date(new Date().getFullYear(), 0, 1);
    const dataToUse = data.ofs.filter(
      (of) => of.ligne?.denomination && of.scoreTotal != null && new Date(of.dateDebut) >= yearStart,
    );

    const res = new Map<string, {
      weightedScore: number;
      totalQty: number;
      posteScoreTotal: number;
      posteCount: number;
    }>();

    for (const of of dataToUse) {
      const key = of.ligne.denomination;
      const qty = parseNumber(of.quantiteProduite ?? 0) || 1;
      const entry = res.get(key) ?? { weightedScore: 0, totalQty: 0, posteScoreTotal: 0, posteCount: 0 };
      entry.weightedScore += of.scoreTotal * qty;
      entry.totalQty += qty;
      entry.posteScoreTotal += of.postes?.reduce((acc, p) => acc + p.score, 0) ?? 0;
      entry.posteCount += of.postes?.length ?? 0;
      res.set(key, entry);
    }

    return [...res.entries()]
      .map(([ligneDenomination, r]) => ({
        ligneDenomination,
        score: (r.totalQty > 0 ? r.weightedScore / r.totalQty : 0).toFixed(0),
        score_poste: (r.posteCount > 0 ? r.posteScoreTotal / r.posteCount : 0).toFixed(0),
      }))
      .sort((a, b) => a.ligneDenomination.localeCompare(b.ligneDenomination));
  }

  static getQuantiteOfChart(
    data: {
      date: string; //yyyy-MM
      nb_ANNULE: number;
      nb_EN_ATTENTE_PLANNIF: number;
      nb_EN_ATTENTE_PROD: number;
      nb_EN_PROD: number;
      nb_EN_ATTENTE_REINTE_PDC: number;
      nb_EN_ATTENTE_VALIDATION: number;
      nb_VALIDE: number;
    }[],
    yearScale: string,
  ) {
    if (!data || !data.length) {
      return [];
    }
    const dataToUse = data.find((d) => d.date === yearScale);
    if (!dataToUse) {
    }
    return [
      {
        key: OfEtat.ANNULE,
        label: EnumsUtils.libelleFromEnum(OfEtat, 'enums.of_etat', OfEtat.ANNULE),
        value: dataToUse.nb_ANNULE,
      },
      {
        key: OfEtat.EN_ATTENTE_PLANNIF,
        label: EnumsUtils.libelleFromEnum(
          OfEtat,
          'enums.of_etat',
          OfEtat.EN_ATTENTE_PLANNIF,
        ),
        value: dataToUse.nb_EN_ATTENTE_PLANNIF,
      },
      {
        key: OfEtat.EN_ATTENTE_PROD,
        label: EnumsUtils.libelleFromEnum(
          OfEtat,
          'enums.of_etat',
          OfEtat.EN_ATTENTE_PROD,
        ),
        value: dataToUse.nb_EN_ATTENTE_PROD,
      },
      {
        key: OfEtat.EN_PROD,
        label: EnumsUtils.libelleFromEnum(
          OfEtat,
          'enums.of_etat',
          OfEtat.EN_PROD,
        ),
        value: dataToUse.nb_EN_PROD,
      },
      {
        key: OfEtat.EN_ATTENTE_REINTE_PDC,
        label: EnumsUtils.libelleFromEnum(
          OfEtat,
          'enums.of_etat',
          OfEtat.EN_ATTENTE_REINTE_PDC,
        ),
        value: dataToUse.nb_EN_ATTENTE_REINTE_PDC,
      },
      {
        key: OfEtat.EN_ATTENTE_VALIDATION,
        label: EnumsUtils.libelleFromEnum(
          OfEtat,
          'enums.of_etat',
          OfEtat.EN_ATTENTE_VALIDATION,
        ),
        value: dataToUse.nb_EN_ATTENTE_VALIDATION,
      },
      {
        key: OfEtat.VALIDE,
        label: EnumsUtils.libelleFromEnum(OfEtat, 'enums.of_etat', OfEtat.VALIDE),
        value: dataToUse.nb_VALIDE,
      },
    ];
  }

  static formatNumeric(n: number, toFixed: number = 1) {
    if (n === 0) return "0";
    const suffixes = ["", "k", "m", "M", "T", "P", "E", "Z", "Y"];
    const tier = (Math.log10(Math.abs(n)) / 3) | 0;

    if (tier == 0) return Number.isInteger(n) ? `${n}` : n.toFixed(toFixed);

    const suffix = suffixes[tier];
    const scale = Math.pow(10, tier * 3);
    const formatted = (n / scale).toFixed(toFixed);

    return `${formatted}${suffix}`;
  }

  static getDateForPeriod(date: string | Date, period: string) {
    const dateInput = new Date(date);
    let d;
    switch (period) {
      case "j":
        d = format(dateInput, "dd-MM-yyyy");
        break;
      case "s":
        d = this.getWeekOfYear(dateInput);
        break;
      case "m":
        d = format(dateInput, "MM-yy");
        break;
      case "a":
        d = format(dateInput, "yyyy");
        break;
    }

    return d;
  }

  static getWeekOfYear(date: Date): string {
    const yearStart = new Date(date.getFullYear(), 0, 1);
    const weekNum = Math.ceil(
      ((date.getTime() - yearStart.getTime()) / 86400000 +
        yearStart.getDay() +
        1) /
        7,
    );
    return `Semaine ${weekNum.toString().padStart(2, "0")} - ${date.getFullYear()}`;
  }

  static getWeek(date: Date): string {
    const yearStart = new Date(date.getFullYear(), 0, 1);
    const weekNum = Math.ceil(
      ((date.getTime() - yearStart.getTime()) / 86400000 +
        yearStart.getDay() +
        1) /
        7,
    );
    return `Semaine ${weekNum.toString().padStart(2, "0")}`;
  }

  /** Mapping WidgetType → clé du Pass pour le droit d'accès individuel. */
  static readonly WIDGET_PASS_KEY: Partial<Record<WidgetType, keyof Pass>> = {
    // Production
    [WidgetType.PRODUCTIVITE_MOYENNE]: "wProductiviteMoyenne",
    [WidgetType.OF_EN_COURS]: "wOfEnCours",
    [WidgetType.HEURES_TRAVAILLES]: "wHeuresTravailles",
    [WidgetType.QUANTITE_OF]: "wQuantiteOf",
    [WidgetType.OF_LIST]: "wOfList",
    [WidgetType.SPECIFICATION_LIST]: "wSpecificationList",
    [WidgetType.QUANTITE_PRODUITE_PERIODE]: "wQuantiteProduitePeriode",
    // Financier
    [WidgetType.CA_CUMULE]: "wCaCumule",
    [WidgetType.CA_PAR_PERIODE]: "wCaParPeriode",
    [WidgetType.CA_DELTA]: "wCaDelta",
    [WidgetType.CA_N_MOINS_1]: "wCaNMoins1",
    [WidgetType.REPARTITION_PAR_CLIENT]: "wRepartitionParClient",
    [WidgetType.COMMANDE_FOURNISSEUR_LIST]: "wCommandeFournisseurList",
    [WidgetType.COMMANDE_CLIENT_LIST]: "wCommandeClientList",
    [WidgetType.VALEUR_PAR_FAMILLE]: "wValeurParFamille",
    // Stock
    [WidgetType.LOT_PAR_ETAT]: "wLotParEtat",
    [WidgetType.EVOLUTION_VALEUR]: "wEvolutionValeur",
    // Supervision
    [WidgetType.PLANNING]: "wPlanning",
    [WidgetType.LIVE_PRODUCTION]: "wLiveProduction",
    // Qualité
    [WidgetType.NC_STATS]: "wNcStats",
    [WidgetType.NC_CLOSURE_METRICS]: "wNcClosureMetrics",
    [WidgetType.NC_SUPPLIER_COMPLIANCE]: "wNcSupplierCompliance",
    [WidgetType.CERTIFICAT_BIO_ECHEANCE]: "wCertificatBioEcheance",
    // Ligne (embedded)
    [WidgetType.QUANTITE_PRODUITE_LIGNE]: "wQuantiteProduiteLigne",
    [WidgetType.MAIN_OEUVRE_LIGNE]: "wMainOeuvreLigne",
    [WidgetType.PRODUCTIVITE_LIGNE]: "wProductiviteLigne",
    [WidgetType.COUTS_LIGNE]: "wCoutsLigne",
    [WidgetType.OFS_LIGNE]: "wOfsLigne",
    [WidgetType.ARTICLES_PRODUITS_LIGNE]: "wArticlesProduitsLigne",
    // Article (embedded)
    [WidgetType.CONSOS_PAR_ARTICLE]: "wConsosParArticle",
    [WidgetType.PRODUCTIONS]: "wProductions",
    [WidgetType.ACHATS]: "wAchats",
    [WidgetType.ACHATS_EVOLUTION]: "wAchatsEvolution",
    [WidgetType.VENTES]: "wVentes",
    [WidgetType.MARGE]: "wMarge",
    [WidgetType.HEURES_OFS]: "wHeuresOfs",
    [WidgetType.CA_PERIODE_ARTICLE]: "wCaPeriodeArticle",
    [WidgetType.CA_CUMULE_ARTICLE]: "wCaCumuleArticle",
    [WidgetType.MOUVEMENTS_ARTICLES]: "wMouvementsArticles",
    [WidgetType.STOCKS_ARTICLE]: "wStocksArticle",
    [WidgetType.QUICK_WIN]: "wQuickWin",
    // Tiers (embedded)
    [WidgetType.ACHATS_EVOLUTION_TIERS]: "wAchatsEvolutionTiers",
    [WidgetType.VENTE_EVOLUTION_TIERS]: "wVenteEvolutionTiers",
    [WidgetType.CA_CUMULE_TIERS]: "wCaCumuleTiers",
    [WidgetType.CA_PAR_PERIODE_TIERS]: "wCaParPeriodeTiers",
    [WidgetType.MARGE_TIERS]: "wMargeTiers",
    [WidgetType.ACHATS_TIERS]: "wAchatsTiers",
    [WidgetType.VENTES_TIERS]: "wVentesTiers",
    [WidgetType.COMMANDES_TIERS]: "wCommandesTiers",
    [WidgetType.COMMANDES_CLIENTS_TIERS]: "wCommandesClientsTiers",
    // User Infos (embedded)
    [WidgetType.HEURES_USER_INFOS]: "wHeuresUserInfos",
    [WidgetType.REPARTITION_TRAVAIL_USER_INFOS]: "wRepartitionTravailUserInfos",
    [WidgetType.OFS_USER_INFOS]: "wOfsUserInfos",
    [WidgetType.PRODUCTIVITE_USER_INFOS]: "wProductiviteUserInfos",
    [WidgetType.LIGNES_USER_INFOS]: "wLignesUserInfos",
    [WidgetType.ARTICLES_PRODUITS_USER_INFOS]: "wArticlesProduitsUserInfos",
  };

  static hasAccessWidget(type: WidgetType, pass: Pass) {
    const key = this.WIDGET_PASS_KEY[type];
    if (!key) return true; // Types sans flag (CADENCE_REELLE, NB_LOT_DLC…)
    return !!pass?.[key];
  }

  static hasAccessCategorie(type: string, pass: Pass) {
    const category = this.widgets.find((c) => c.type === type);
    if (!category) return true;
    return category.modules.some((m) => this.hasAccessWidget(m.type, pass));
  }
}
